export default "__VITE_ASSET__DepMH_Vs__"